import { render, staticRenderFns } from "./ExchangeTable.html?vue&type=template&id=4e788682&scoped=true&"
import script from "./ExchangeTable.js?vue&type=script&lang=js&"
export * from "./ExchangeTable.js?vue&type=script&lang=js&"
import style0 from "./ExchangeTable.scss?vue&type=style&index=0&id=4e788682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e788682",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VPagination,VRow,VSkeletonLoader})
